import EmblaCarousel from 'embla-carousel'
import { addDotBtnsAndClickHandlers } from './js/embla-carousel-dots.js'
import { addPrevNextBtnsClickHandlers } from './js/embla-carousel-arrows.js'


// ========================= Header menu mobile =========================
document.addEventListener("DOMContentLoaded", function() {
    /* START ============= MENU MOBILE */
    const smdev_header = document.querySelector('.smdev_header');
    const smdev_header_btn_burger = document.querySelector(".smdev_header_btn_burger");
    const smdev_header_btn_burger_div = document.querySelector(".smdev_header_btn_burger div");
    const smdev_drawer = document.querySelector('.smdev_drawer');
    const smdev_backdrop = document.querySelector('.smdev_drawer_backdrop');

    // toggle menu transparent
    function handleHeaderScroll() {
        if (window.scrollY > 40) {
            smdev_header.classList.add("bg-space900");
            smdev_header.classList.add("smdev_header_scroll");
        } else {
            smdev_header.classList.remove("bg-space900");
            smdev_header.classList.remove("smdev_header_scroll");
        }
    }

    if (smdev_header) {
        document.addEventListener("scroll", handleHeaderScroll);
        handleHeaderScroll();
    }

    if (!smdev_drawer || !smdev_header_btn_burger) return;

    const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const isOpen = () => smdev_drawer.classList.contains('is-open');

    // O burger fica fora do painel mas funciona como botao fechar,
    // entao ele entra no ciclo de foco junto com o conteudo do drawer.
    function focusables() {
        return [smdev_header_btn_burger, ...smdev_drawer.querySelectorAll(FOCUSABLE)]
            .filter(el => el.offsetParent !== null);
    }

    function resetSubmenus() {
        smdev_drawer.querySelectorAll('.menu-item-has-children.is-open').forEach(item => {
            item.classList.remove('is-open');
            const link = item.querySelector(':scope > a');
            if (link) link.setAttribute('aria-expanded', 'false');
        });
    }

    function openDrawer() {
        smdev_drawer.classList.add('is-open');
        if (smdev_backdrop) smdev_backdrop.classList.add('is-open');
        smdev_header_btn_burger_div.classList.add('smdev_close_icon');
        smdev_header_btn_burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';

        const first = smdev_drawer.querySelector(FOCUSABLE);
        if (first) first.focus({ preventScroll: true });
    }

    function closeDrawer(returnFocus) {
        smdev_drawer.classList.remove('is-open');
        if (smdev_backdrop) smdev_backdrop.classList.remove('is-open');
        smdev_header_btn_burger_div.classList.remove('smdev_close_icon');
        smdev_header_btn_burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';

        if (returnFocus) smdev_header_btn_burger.focus({ preventScroll: true });
    }

    // Submenus so voltam ao estado inicial depois que o painel terminou de
    // sair — se resetasse na hora, o usuario veria o submenu colapsando.
    smdev_drawer.addEventListener('transitionend', function(event) {
        if (event.target !== smdev_drawer || event.propertyName !== 'transform') return;
        if (!isOpen()) resetSubmenus();
    });

    smdev_header_btn_burger.addEventListener('click', function(event) {
        event.preventDefault();
        isOpen() ? closeDrawer(true) : openDrawer();
    });

    if (smdev_backdrop) {
        smdev_backdrop.addEventListener('click', () => closeDrawer(true));
    }

    // Item com filhos nao navega: ele abre/fecha o submenu.
    smdev_drawer.querySelectorAll('.menu-item-has-children > a').forEach(link => {
        link.setAttribute('aria-expanded', 'false');
    });

    smdev_drawer.addEventListener('click', function(event) {
        const link = event.target.closest('a');
        if (!link) return;

        const item = link.parentElement;
        const isParentLink = item
            && item.classList.contains('menu-item-has-children')
            && link === item.querySelector(':scope > a');

        if (isParentLink) {
            event.preventDefault();
            const willOpen = !item.classList.contains('is-open');
            item.classList.toggle('is-open', willOpen);
            link.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            return;
        }

        // link comum: navega normalmente e fecha o painel
        closeDrawer(false);
    });

    document.addEventListener('keydown', function(event) {
        if (!isOpen()) return;

        if (event.key === 'Escape') {
            closeDrawer(true);
            return;
        }

        if (event.key !== 'Tab') return;

        // prende o foco dentro do menu enquanto ele estiver aberto
        const items = focusables();
        if (!items.length) return;

        const first = items[0];
        const last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    // Girou a tela / passou para desktop com o menu aberto: fecha e devolve o scroll.
    window.addEventListener('resize', function() {
        if (isOpen() && window.innerWidth > 1100) closeDrawer(false);
    });
    /* END ============= MENU MOBILE */
});
// ========================= /Header menu mobile =========================


// ==================== accordion faq ==================== //
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.accordionTrigger').forEach(button => {
        button.addEventListener('click', () => {

            const content = button.querySelector('.accordionContent');
            const iconPlus = button.querySelector(".iconPlus svg");

            if (content.classList.contains("open")) {
                content.style.maxHeight = null;
                content.classList.remove("open");
                if (iconPlus) {
                    iconPlus.style.transform = 'rotate(0deg)';
                    iconPlus.style.color = '';
                }
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
                content.classList.add("open");
                if (iconPlus) {
                    iconPlus.style.transform = 'rotate(45deg)';
                    iconPlus.style.color = '#C20000';

                }
            }
        });
    });

 });
// ==================== /accordion faq ==================== //


// ==================== dropdown de categorias (blog) ==================== //
// O abrir/fechar e do proprio <details> — aqui so entram os dois
// comportamentos que o elemento nativo nao da: fechar ao clicar fora e no Esc.
document.addEventListener("DOMContentLoaded", () => {
    const dropdowns = document.querySelectorAll('.catDropdown');
    if (!dropdowns.length) return;

    document.addEventListener('click', (event) => {
        dropdowns.forEach(dropdown => {
            if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        dropdowns.forEach(dropdown => {
            if (!dropdown.open) return;
            dropdown.open = false;

            // devolve o foco para o gatilho, senao ele fica perdido no painel fechado
            const summary = dropdown.querySelector('summary');
            if (summary) summary.focus();
        });
    });
});
// ==================== /dropdown de categorias (blog) ==================== //











// ==================== embla carousel ==================== //
document.addEventListener('DOMContentLoaded', () => {
    const emblaNode = document.querySelector('.embla');
    if (!emblaNode) return;
  
    const emblaApi = EmblaCarousel(emblaNode, {
      loop: true,
      align: 'center',
      containScroll: 'trimSnaps',
      skipSnaps: true,
    });
  
    // ir direto para o slide do meio
    const middle = Math.floor((emblaApi.slideNodes().length - 1) / 2);
    emblaApi.scrollTo(middle, true);
  
    // dots
    const dotsNode = emblaNode.querySelector(':scope > .embla__dots');
    if (dotsNode) {
      const removeDots = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
      emblaApi.on('destroy', removeDots);
    }
  
    // prev/next
    const prevBtn = emblaNode.querySelector(':scope > .embla__buttons > .embla__button--prev');
    const nextBtn = emblaNode.querySelector(':scope > .embla__buttons > .embla__button--next');
    if (prevBtn && nextBtn) {
      const removeArrows = addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);
      emblaApi.on('destroy', removeArrows);
    }
  });
  
// ==================== /embla carousel ==================== //




// ==================== video modal ==================== //
document.addEventListener("DOMContentLoaded", function() {
    const btn = document.querySelector(".btn-ver-video");
    const modal = document.getElementById("video-modal");
    if(modal){
        const closeBtn = modal.querySelector(".close");
        const iframe = document.getElementById("video-frame");
    
    
            btn.addEventListener("click", function() {
                const videoCode = btn.dataset.video; // pega o código do vídeo do atributo data-video
                const embedURL = "https://www.youtube-nocookie.com/embed/" + videoCode + "?autoplay=1";
                iframe.src = embedURL;
                modal.style.display = "flex";
            });
    
            closeBtn.addEventListener("click", function() {
                modal.style.display = "none";
                iframe.src = "";
            });
    }

    window.addEventListener("click", function(e) {
        if (e.target === modal) {
            modal.style.display = "none";
            iframe.src = "";
        }
    });
});


// ==================== /video modal ==================== //




// ==================== grafismo de linhas ==================== //
// Dispara o desenho do traco quando o grafismo entra no viewport.
// Toda a coreografia (duracao, sentido, delay de cada circulo) esta no CSS
// e nas custom properties da marcacao — aqui so entra a classe .is-drawing.
document.addEventListener("DOMContentLoaded", () => {
    const grafismos = document.querySelectorAll('.linhas_grafismo');
    if (!grafismos.length) return;

    // Navegador sem IntersectionObserver: mostra o desenho pronto.
    if (!('IntersectionObserver' in window)) {
        grafismos.forEach(el => el.classList.add('is-drawing'));
        return;
    }

    // threshold 0 de proposito: estes grafismos sangram para fora da tela e o
    // <main> tem overflow-x-hidden, entao boa parte deles fica cortada. Em
    // 1368px, por exemplo, so 87 dos 388px do grafismo da hero sobram visiveis
    // (22%) — com threshold 0.25 a animacao nunca disparava abaixo de ~1388px.
    // Quem segura o gatilho agora e o rootMargin, nao a fracao de area.
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-drawing');
            obs.unobserve(entry.target); // anima uma vez so
        });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

    grafismos.forEach(el => observer.observe(el));
});
// ==================== /grafismo de linhas ==================== //